import * as React from 'react';
import { useState, useRef, useEffect, useCallback } from 'react';
import Select from '../../../../components/Select';

const SingleOptionFilter = (props) => {
    const { filterOptions, selectedValue, isSelectOption, styleClass, isOpenRight, appliedSort, onApplyFilter, onClose } = props;

    const [filterValue, setFilterValue] = useState(null);
    const sortRef = useRef(null);

    // Change filter handler
    const onChangeFilter = useCallback((value) => {
        setFilterValue(value);
        onApplyFilter(value);
    }, [onApplyFilter]);

    // Close filter pop up handler
    const onCloseFilter = useCallback(() => {
        onClose();
    }, [onClose]);

    const handleOutsideClick = useCallback((event) => {
        if (sortRef.current && !sortRef.current.contains(event.target)) {
            onCloseFilter();
        }
    }, [onCloseFilter]);

    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);
        return () => document.removeEventListener('mousedown', handleOutsideClick);
    }, [handleOutsideClick]);

    return (
        <>
            {
                isSelectOption ?
                    <Select
                        options={filterOptions?.map((data, key) => (
                            { value: data.value, label: data.name }
                        ))}
                        onSelect={(value) => onChangeFilter(value)}
                        selected={selectedValue ? selectedValue : (filterValue ? filterValue : filterOptions[0].value)}
                        openOnClick={true}
                        iconName="downArrow"
                        styleClass={`ml ${styleClass}`}
                        isOpenRight={isOpenRight}
                    />
                    :
                    //todo: block need or not
                    <div className="dropDownMenu overlap onClick filter openLeft" ref={sortRef}>
                        <div className="header">
                            <header className="alignMiddle">
                                Sort by
                            </header>
                        </div>
                        <ul className="colFlex ml__1 flexWrap">
                            {
                                filterOptions && filterOptions.map((data, key) => (
                                    <li key={key}>
                                        <a className="flexGrow" href="javascript:void(0)">
                                            <input type="radio" name="activity_template" className="gap" id={key} onClick={() => onChangeFilter(data.value)} checked={appliedSort == data.value} />
                                            <label htmlFor={key}>{data.name}</label>
                                        </a>
                                    </li>
                                ))
                            }
                        </ul>
                        <footer>
                            <div className="actions alignRight">
                                <a className="btn link" href="javascript:void(0)" onClick={onCloseFilter}>Close</a>
                            </div>
                        </footer>
                    </div>
            }
        </>
    );
};

export default React.memo(SingleOptionFilter);